import React, { useState } from "react";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import css from "./FilterModal.module.css";
import { Button } from "../../../../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import {
  CancelIconBlack,
  BookmarkIconBlack,
} from "../../../../../constant/imagePath";
import Colors from "../../../../../stories/assets/Colors";
import { ReactSVG } from "react-svg";
import ModalSkeletonCssClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import moment from "moment";

const FilterModal = ({ show, setShow, staticData, data, setData }) => {
  const [rating, setRating] = useState({
    label: "All Rates",
    value: "all-rates",
  });
  const [newestOrOldest, setNewestOrOldest] = useState({});

  function onApply() {
    console.log(newestOrOldest?.value == "oldest-first", "aaa");
    let newData = [...staticData];
    if (newestOrOldest?.value == "newest-first") {
      let filterData = [];
      filterData = newData?.filter(
        (item) => moment(item?.createdAt).diff(moment().format(), "months") == 0
      );
      newData = filterData;
      setData(filterData);
    }
    if (newestOrOldest?.value == "oldest-first") {
      let filterData = [];
      filterData = newData?.filter(
        (item) =>
          moment(item?.createdAt).diff(moment().format(), "months") !== 0
      );
      newData = filterData;
      setData(filterData);
    }

    setData(
      rating?.value == "all-rates"
        ? newData
        : newData?.filter(
            (item) =>
              item?.rating?.toFixed(0) == parseInt(rating?.value).toFixed(0)
          )
    );
    setShow(false);
  }

  return (
    <>
      <style>{`
      .${ModalSkeletonCssClasses.body} {
        padding: 0px;
      }
          .modal .modal-dialog {
            width: 100% !important;
            margin: 0px !important;
          }
          .modal .modal-dialog {
            max-width: 100% !important;
            height: 100%;
        }
        .modal-content{
            min-height:100%
        }
        .modal { 
            border-radius: 0px;
            background: white;
          }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"0px"}
        width={"100%"}
      >
        <Row className="g-0">
          <Col sm={12} md={12}>
            <div
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
              className={[css.FilterHeader].join(" ")}
            >
              <ReactSVG src={CancelIconBlack} onClick={() => setShow(false)} />

              <h6
                style={{
                  ...Fonts.b3,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Filters
              </h6>
              <ReactSVG src={BookmarkIconBlack} />
            </div>
          </Col>
          <Col sm={12} md={12} className={css.mb32}>
            <div className={[css.DropDownDiv].join(" ")}>
              <DropDown
                label={"Show"}
                placeholder={"Newest first"}
                options={[
                  { label: "Newest first", value: "newest-first" },
                  { label: "Oldest first", value: "oldest-first" },
                ]}
                setter={setNewestOrOldest}
                state={newestOrOldest}
              />
            </div>
          </Col>
          <Col sm={12} md={12} className={css.mb32}>
            <div className={[css.DropDownDiv].join(" ")}>
              <DropDown
                label={"Rating"}
                placeholder={"All Rates"}
                options={[
                  { label: "All Rates", value: "all-rates" },
                  { label: "1 star", value: "1" },
                  { label: "2 stars", value: "2" },
                  { label: "3 stars", value: "3" },
                  { label: "4 stars", value: "4" },
                  { label: "5 stars", value: "5" },
                ]}
                setter={setRating}
                state={rating}
              />
            </div>
          </Col>
          <Col md={12}>
            <div
              style={{
                borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
              className={[css.footerBtnsDiv].join(" ")}
            >
              <LinkButtonWithIcon
                text={"Clear All"}
                textColor={Colors.neutralShadesOfNero}
                customStyle={{
                  ...Fonts.b1Mobile,
                }}
                onClick={() => {
                  setRating({});
                  setNewestOrOldest({});
                }}
              />

              <Button
                label={"Apply"}
                customStyle={{
                  ...Fonts.b1Mobile,
                  padding: "12px 32px",
                  border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  width: "156px",
                }}
                primary={true}
                size="Large"
                onClick={onApply}
              />
            </div>
          </Col>
        </Row>
      </ModalSkeleton>
    </>
  );
};

export default FilterModal;
